import styled from '@emotion/styled';

export const Overlay = styled.div<{isVisible: boolean}>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(17, 24, 39, 0.1);
  backdrop-filter: blur(3px);
  z-index: 998; /* Under the sidebar but above other content */
  opacity: ${({isVisible}) => (isVisible ? 1 : 0)};
  visibility: ${({isVisible}) => (isVisible ? 'visible' : 'hidden')};
  transition:
    opacity 0.3s ease,
    visibility 0.3s ease;
`;
